import React from 'react';
import BrowserUtils from '../../utils/BrowserUtils';

const BrowserFormFactor = (ComposedComponent) =>
  class extends React.Component {
    constructor(props) {
      super(props);
      this.onResize = this.onResize.bind(this);
      this.state = {
        browserView: BrowserUtils.getDevice(),
      };
    }
    componentWillMount() {
      window.addEventListener('resize', this.onResize);
    }
    componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
    onResize() {
      const device = BrowserUtils.getDevice();
      if (device !== this.state.browserView) {
        this.setState({
          browserView: device,
        });
        this.state.browserView = device;
      }
    }

    render() {
      return (
        <ComposedComponent
          {...this.props}
          browserView={this.state.browserView}
        />
      );
    }
  };

export default BrowserFormFactor;
